/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface InvoicesService {
  /** @summary Get All */
  getAllInvoicesGet: {
    /** @summary Get All */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<GetAllInvoicesGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllInvoicesGetSchema,
        options: {
          parameters: GetAllInvoicesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllInvoicesGetData, GetAllInvoicesGetError>>
    ): Promise<RequestFnResponse<GetAllInvoicesGetData, GetAllInvoicesGetError>>;
    /** @summary Get All */
    getQueryKey(
      parameters: DeepReadonly<GetAllInvoicesGetParameters> | void
    ): ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.invoicesService.getAllInvoicesGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.invoicesService.getAllInvoicesGet.useQuery({
     *     query: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllInvoicesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        | (DeepReadonly<GetAllInvoicesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllInvoicesGetData,
          GetAllInvoicesGetError,
          TData,
          ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllInvoicesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.invoicesService.getAllInvoicesGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.invoicesService.getAllInvoicesGet.useQuery({
     *     query: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetAllInvoicesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        | (DeepReadonly<GetAllInvoicesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllInvoicesGetData,
          GetAllInvoicesGetError,
          TData,
          ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllInvoicesGetError>>;
    /** @summary Get All */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllInvoicesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.invoicesService.getAllInvoicesGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             customer_id: initialCustomerId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllInvoicesGetParameters,
      TQueryFnData = GetAllInvoicesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllInvoicesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        | (DeepReadonly<GetAllInvoicesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllInvoicesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllInvoicesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.invoicesService.getAllInvoicesGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             customer_id: initialCustomerId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllInvoicesGetParameters,
      TQueryFnData = GetAllInvoicesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllInvoicesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        | (DeepReadonly<GetAllInvoicesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllInvoicesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllInvoicesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllInvoicesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllInvoicesGetTotal = qraft.invoicesService.getAllInvoicesGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getAllInvoicesGetByParametersTotal = qraft.invoicesService.getAllInvoicesGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             customer_id: customerId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllInvoicesGetResults = qraft.invoicesService.getAllInvoicesGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             query: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getAllInvoicesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllInvoicesGetCombinedResults = qraft.invoicesService.getAllInvoicesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             query: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getAllInvoicesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllInvoicesGetSchema,
          GetAllInvoicesGetParameters,
          GetAllInvoicesGetData,
          GetAllInvoicesGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllInvoicesGetData, GetAllInvoicesGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetAllInvoicesGetData, GetAllInvoicesGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.invoicesService.getAllInvoicesGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.invoicesService.getAllInvoicesGet.useSuspenseQuery({
     *     query: {
     *         customer_id: customerId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetAllInvoicesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        | (DeepReadonly<GetAllInvoicesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllInvoicesGetData,
          GetAllInvoicesGetError,
          TData,
          ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllInvoicesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.invoicesService.getAllInvoicesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             customer_id: initialCustomerId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetAllInvoicesGetParameters, TData = GetAllInvoicesGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        | (DeepReadonly<GetAllInvoicesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllInvoicesGetData,
          GetAllInvoicesGetError,
          OperationInfiniteData<TData, GetAllInvoicesGetParameters>,
          ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllInvoicesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllInvoicesGetParameters>,
      OperationError<GetAllInvoicesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllInvoicesGetData = qraft.invoicesService.getAllInvoicesGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             query: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getAllInvoicesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllInvoicesGetCombinedData = qraft.invoicesService.getAllInvoicesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 customer_id: customerId1
     *             }
     *         },
     *         {
     *             query: {
     *                 customer_id: customerId2
     *             }
     *         }
     *     ]
     * });
     * getAllInvoicesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllInvoicesGetSchema,
          GetAllInvoicesGetParameters,
          GetAllInvoicesGetData,
          GetAllInvoicesGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetAllInvoicesGetData, GetAllInvoicesGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetAllInvoicesGetData, GetAllInvoicesGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get All */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllInvoicesGetSchema,
        GetAllInvoicesGetData,
        GetAllInvoicesGetParameters,
        GetAllInvoicesGetError
      > | void
    ): Promise<GetAllInvoicesGetData>;
    /** @summary Get All */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllInvoicesGetSchema,
        GetAllInvoicesGetData,
        GetAllInvoicesGetParameters,
        GetAllInvoicesGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllInvoicesGetSchema,
        GetAllInvoicesGetData,
        GetAllInvoicesGetParameters,
        GetAllInvoicesGetError
      > | void
    ): Promise<GetAllInvoicesGetData>;
    /** @summary Get All */
    fetchInfiniteQuery<TPageParam extends GetAllInvoicesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllInvoicesGetSchema,
        GetAllInvoicesGetData,
        GetAllInvoicesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllInvoicesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllInvoicesGetData, GetAllInvoicesGetParameters>>;
    /** @summary Get All */
    prefetchInfiniteQuery<TPageParam extends GetAllInvoicesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllInvoicesGetSchema,
        GetAllInvoicesGetData,
        GetAllInvoicesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllInvoicesGetError
      > | void
    ): Promise<void>;
    /** @summary Get All */
    ensureInfiniteQueryData<TPageParam extends GetAllInvoicesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllInvoicesGetSchema,
        GetAllInvoicesGetData,
        GetAllInvoicesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllInvoicesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllInvoicesGetData, GetAllInvoicesGetParameters>>;
    /** @summary Get All */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        | (DeepReadonly<GetAllInvoicesGetParameters> | void)
    ): GetAllInvoicesGetData | undefined;
    /** @summary Get All */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        | (DeepReadonly<GetAllInvoicesGetParameters> | void)
    ): OperationInfiniteData<GetAllInvoicesGetData, GetAllInvoicesGetParameters> | undefined;
    /** @summary Get All */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>,
            data: NoInfer<OperationInfiniteData<GetAllInvoicesGetData, GetAllInvoicesGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>,
            data: GetAllInvoicesGetData | undefined,
          ]
        >;
    /** @summary Get All */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        | (DeepReadonly<GetAllInvoicesGetParameters> | void)
    ): QueryState<GetAllInvoicesGetData, GetAllInvoicesGetError> | undefined;
    /** @summary Get All */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllInvoicesGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>
        | void
    ):
      | QueryState<OperationInfiniteData<GetAllInvoicesGetData, GetAllInvoicesGetParameters>, GetAllInvoicesGetError>
      | undefined;
    /** @summary Get All */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllInvoicesGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>,
      updater: Updater<
        NoInfer<GetAllInvoicesGetData> | undefined,
        NoInfer<DeepReadonly<GetAllInvoicesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllInvoicesGetData | undefined;
    /** @summary Get All */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllInvoicesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<GetAllInvoicesGetSchema, GetAllInvoicesGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetAllInvoicesGetData, GetAllInvoicesGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetAllInvoicesGetData, GetAllInvoicesGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllInvoicesGetData, GetAllInvoicesGetParameters> | undefined;
    /** @summary Get All */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >,
      updater: Updater<NoInfer<GetAllInvoicesGetData> | undefined, NoInfer<GetAllInvoicesGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetAllInvoicesGetData | undefined>;
    /** @summary Get All */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllInvoicesGetSchema,
        GetAllInvoicesGetData,
        TInfinite,
        GetAllInvoicesGetParameters,
        GetAllInvoicesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get All */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get All */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get All */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
    ): void;
    /** @summary Get All */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get All */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllInvoicesGetSchema,
            GetAllInvoicesGetData,
            TInfinite,
            GetAllInvoicesGetParameters,
            GetAllInvoicesGetError
          >
    ): number;
    schema: GetAllInvoicesGetSchema;
    types: {
      parameters: GetAllInvoicesGetParameters;
      data: GetAllInvoicesGetData;
      error: GetAllInvoicesGetError;
    };
  };
  /** @summary Get */
  getInvoicesInvoiceIdGet: {
    /** @summary Get */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetInvoicesInvoiceIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetInvoicesInvoiceIdGetSchema,
        options: {
          parameters: GetInvoicesInvoiceIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetError>>
    ): Promise<RequestFnResponse<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetError>>;
    /** @summary Get */
    getQueryKey(
      parameters: DeepReadonly<GetInvoicesInvoiceIdGetParameters>
    ): ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.invoicesService.getInvoicesInvoiceIdGet.useQuery({
     *     path: {
     *         invoice_id: invoiceId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetInvoicesInvoiceIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetInvoicesInvoiceIdGetData,
          GetInvoicesInvoiceIdGetError,
          TData,
          ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetInvoicesInvoiceIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.invoicesService.getInvoicesInvoiceIdGet.useQuery({
     *     path: {
     *         invoice_id: invoiceId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetInvoicesInvoiceIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetInvoicesInvoiceIdGetData,
          GetInvoicesInvoiceIdGetError,
          TData,
          ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetInvoicesInvoiceIdGetError>>;
    /** @summary Get */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetInvoicesInvoiceIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.invoicesService.getInvoicesInvoiceIdGet.useInfiniteQuery({
     *     path: {
     *         invoice_id: invoiceId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetInvoicesInvoiceIdGetParameters,
      TQueryFnData = GetInvoicesInvoiceIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetInvoicesInvoiceIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetInvoicesInvoiceIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetInvoicesInvoiceIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.invoicesService.getInvoicesInvoiceIdGet.useInfiniteQuery({
     *     path: {
     *         invoice_id: invoiceId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetInvoicesInvoiceIdGetParameters,
      TQueryFnData = GetInvoicesInvoiceIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetInvoicesInvoiceIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetInvoicesInvoiceIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetInvoicesInvoiceIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetInvoicesInvoiceIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getInvoicesInvoiceIdGetTotal = qraft.invoicesService.getInvoicesInvoiceIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getInvoicesInvoiceIdGetByParametersTotal = qraft.invoicesService.getInvoicesInvoiceIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             invoice_id: invoiceId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
        | QueryFiltersByQueryKey<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getInvoicesInvoiceIdGetResults = qraft.invoicesService.getInvoicesInvoiceIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 invoice_id: invoiceId1
     *             }
     *         },
     *         {
     *             path: {
     *                 invoice_id: invoiceId2
     *             }
     *         }
     *     ]
     * });
     * getInvoicesInvoiceIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getInvoicesInvoiceIdGetCombinedResults = qraft.invoicesService.getInvoicesInvoiceIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 invoice_id: invoiceId1
     *             }
     *         },
     *         {
     *             path: {
     *                 invoice_id: invoiceId2
     *             }
     *         }
     *     ]
     * });
     * getInvoicesInvoiceIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetInvoicesInvoiceIdGetSchema,
          GetInvoicesInvoiceIdGetParameters,
          GetInvoicesInvoiceIdGetData,
          GetInvoicesInvoiceIdGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.invoicesService.getInvoicesInvoiceIdGet.useSuspenseQuery({
     *     path: {
     *         invoice_id: invoiceId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetInvoicesInvoiceIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetInvoicesInvoiceIdGetData,
          GetInvoicesInvoiceIdGetError,
          TData,
          ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetInvoicesInvoiceIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.invoicesService.getInvoicesInvoiceIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         invoice_id: invoiceId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetInvoicesInvoiceIdGetParameters, TData = GetInvoicesInvoiceIdGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetInvoicesInvoiceIdGetData,
          GetInvoicesInvoiceIdGetError,
          OperationInfiniteData<TData, GetInvoicesInvoiceIdGetParameters>,
          ServiceOperationInfiniteQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetInvoicesInvoiceIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetInvoicesInvoiceIdGetParameters>,
      OperationError<GetInvoicesInvoiceIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getInvoicesInvoiceIdGetData = qraft.invoicesService.getInvoicesInvoiceIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 invoice_id: invoiceId1
     *             }
     *         },
     *         {
     *             path: {
     *                 invoice_id: invoiceId2
     *             }
     *         }
     *     ]
     * });
     * getInvoicesInvoiceIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getInvoicesInvoiceIdGetCombinedData = qraft.invoicesService.getInvoicesInvoiceIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 invoice_id: invoiceId1
     *             }
     *         },
     *         {
     *             path: {
     *                 invoice_id: invoiceId2
     *             }
     *         }
     *     ]
     * });
     * getInvoicesInvoiceIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetInvoicesInvoiceIdGetSchema,
          GetInvoicesInvoiceIdGetParameters,
          GetInvoicesInvoiceIdGetData,
          GetInvoicesInvoiceIdGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetInvoicesInvoiceIdGetSchema,
        GetInvoicesInvoiceIdGetData,
        GetInvoicesInvoiceIdGetParameters,
        GetInvoicesInvoiceIdGetError
      >
    ): Promise<GetInvoicesInvoiceIdGetData>;
    /** @summary Get */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetInvoicesInvoiceIdGetSchema,
        GetInvoicesInvoiceIdGetData,
        GetInvoicesInvoiceIdGetParameters,
        GetInvoicesInvoiceIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetInvoicesInvoiceIdGetSchema,
        GetInvoicesInvoiceIdGetData,
        GetInvoicesInvoiceIdGetParameters,
        GetInvoicesInvoiceIdGetError
      >
    ): Promise<GetInvoicesInvoiceIdGetData>;
    /** @summary Get */
    fetchInfiniteQuery<TPageParam extends GetInvoicesInvoiceIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetInvoicesInvoiceIdGetSchema,
        GetInvoicesInvoiceIdGetData,
        GetInvoicesInvoiceIdGetParameters,
        DeepReadonly<TPageParam>,
        GetInvoicesInvoiceIdGetError
      >
    ): Promise<OperationInfiniteData<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetParameters>>;
    /** @summary Get */
    prefetchInfiniteQuery<TPageParam extends GetInvoicesInvoiceIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetInvoicesInvoiceIdGetSchema,
        GetInvoicesInvoiceIdGetData,
        GetInvoicesInvoiceIdGetParameters,
        DeepReadonly<TPageParam>,
        GetInvoicesInvoiceIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureInfiniteQueryData<TPageParam extends GetInvoicesInvoiceIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetInvoicesInvoiceIdGetSchema,
        GetInvoicesInvoiceIdGetData,
        GetInvoicesInvoiceIdGetParameters,
        DeepReadonly<TPageParam>,
        GetInvoicesInvoiceIdGetError
      >
    ): Promise<OperationInfiniteData<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetParameters>>;
    /** @summary Get */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>
    ): GetInvoicesInvoiceIdGetData | undefined;
    /** @summary Get */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>
    ): OperationInfiniteData<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetParameters> | undefined;
    /** @summary Get */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
        | QueryFiltersByQueryKey<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetInvoicesInvoiceIdGetSchema,
              GetInvoicesInvoiceIdGetParameters
            >,
            data:
              | NoInfer<OperationInfiniteData<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>,
            data: GetInvoicesInvoiceIdGetData | undefined,
          ]
        >;
    /** @summary Get */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>
    ): QueryState<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetError> | undefined;
    /** @summary Get */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>
    ):
      | QueryState<
          OperationInfiniteData<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetParameters>,
          GetInvoicesInvoiceIdGetError
        >
      | undefined;
    /** @summary Get */
    setQueryData(
      parameters:
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>
        | ServiceOperationQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>,
      updater: Updater<
        NoInfer<GetInvoicesInvoiceIdGetData> | undefined,
        NoInfer<DeepReadonly<GetInvoicesInvoiceIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetInvoicesInvoiceIdGetData | undefined;
    /** @summary Get */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetInvoicesInvoiceIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetInvoicesInvoiceIdGetSchema, GetInvoicesInvoiceIdGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetInvoicesInvoiceIdGetData, GetInvoicesInvoiceIdGetParameters> | undefined;
    /** @summary Get */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
        | QueryFiltersByQueryKey<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >,
      updater: Updater<
        NoInfer<GetInvoicesInvoiceIdGetData> | undefined,
        NoInfer<GetInvoicesInvoiceIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetInvoicesInvoiceIdGetData | undefined>;
    /** @summary Get */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetInvoicesInvoiceIdGetSchema,
        GetInvoicesInvoiceIdGetData,
        TInfinite,
        GetInvoicesInvoiceIdGetParameters,
        GetInvoicesInvoiceIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
        | QueryFiltersByQueryKey<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
        | QueryFiltersByQueryKey<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
        | QueryFiltersByQueryKey<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
    ): void;
    /** @summary Get */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
        | QueryFiltersByQueryKey<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
        | QueryFiltersByQueryKey<
            GetInvoicesInvoiceIdGetSchema,
            GetInvoicesInvoiceIdGetData,
            TInfinite,
            GetInvoicesInvoiceIdGetParameters,
            GetInvoicesInvoiceIdGetError
          >
    ): number;
    schema: GetInvoicesInvoiceIdGetSchema;
    types: {
      parameters: GetInvoicesInvoiceIdGetParameters;
      data: GetInvoicesInvoiceIdGetData;
      error: GetInvoicesInvoiceIdGetError;
    };
  };
}
/** @summary Get All */
export const getAllInvoicesGet = {
  schema: {
    method: 'get',
    url: '/invoices',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllInvoicesGetSchema;
  [QraftServiceOperationsToken]: InvoicesService['getAllInvoicesGet'];
};
/** @summary Get */
export const getInvoicesInvoiceIdGet = {
  schema: {
    method: 'get',
    url: '/invoices/{invoice_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetInvoicesInvoiceIdGetSchema;
  [QraftServiceOperationsToken]: InvoicesService['getInvoicesInvoiceIdGet'];
};
export const invoicesService = {
  getAllInvoicesGet,
  getInvoicesInvoiceIdGet,
} as const;
type GetAllInvoicesGetSchema = {
  method: 'get';
  url: '/invoices';
  security: ['HTTPBearer'];
};
type GetAllInvoicesGetParameters = paths['/invoices']['get']['parameters'];
type GetAllInvoicesGetData = paths['/invoices']['get']['responses']['200']['content']['application/json'];
type GetAllInvoicesGetError = paths['/invoices']['get']['responses']['422']['content']['application/json'];
type GetInvoicesInvoiceIdGetSchema = {
  method: 'get';
  url: '/invoices/{invoice_id}';
  security: ['HTTPBearer'];
};
type GetInvoicesInvoiceIdGetParameters = paths['/invoices/{invoice_id}']['get']['parameters'];
type GetInvoicesInvoiceIdGetData =
  paths['/invoices/{invoice_id}']['get']['responses']['200']['content']['application/json'];
type GetInvoicesInvoiceIdGetError =
  paths['/invoices/{invoice_id}']['get']['responses']['422']['content']['application/json'];
